import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Call, CallRecordings, ENVIRONMENT, Environment } from '@domains';
import { map, Observable, switchMap, tap } from 'rxjs';

import { BaseApiService } from '../base-api.service';

@Injectable({ providedIn: 'root' })
export class CallsService extends BaseApiService<Call> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'calls', Call, 'Call');
  }

  getRecordings(callId: string): Observable<CallRecordings> {
    return this.http.get<CallRecordings>(this.config.urls.baseUrl + '/calls/' + callId + '/recordings').pipe(map((response) => response));
  }

  override update(id: string, item: Call): Observable<Call> {
    return super.update(id, item).pipe(
      tap((callData: Call) => {
        window.parent.postMessage({ type: 'callDataUpdated', callData }, '*');
      }),
    );
  }

  redactRecording(callId: string, recordingId: string): Observable<Call> {
    return this.http
      .put<Call>(`${this.config.urls.baseUrl}/calls/${callId}`, { redacted_recording_ids: [recordingId] })
      .pipe(switchMap(() => this.find(callId)));
  }
}
